<!-- 收款台信息 -->
<template>
   <div class="page_content">
      <!-- <subComponents ref="showSelectData"></subComponents> -->
      <el-dialog :visible.sync="showStatus" :title="actionData.cate === 0 ? '新增收款台信息' : '编辑收款台信息'" width="50%" :modal-append-to-body="true" :append-to-body="true" :close-on-click-modal="false"
                 :close-on-press-escape="true" center>
         <cashDeskModal v-if="showStatus" ref="storeMastRef" @drawerCancel="drawerCancel" @toDetail="toDetail" :actionData="actionData"></cashDeskModal>
      </el-dialog>
      <div class="page_content_top">
         <v-button :buttonList="buttonList" @actionSet="actionSet" @getPageInfo="getPageInfo" @openFormDesign="openFormDesign" :buttonFlag="false"></v-button>
         <div class="page_content_top_line">
            <v-search :searchList="searchList" :getRequestData="getRequestData" @searchData="searchData" @openSearch="openSearch"></v-search>
         </div>
      </div>
      <div style="display: flex; just-content: space-between">
         <div class="page_content_center" style="width: 82%">
            <el-table :key="tableFlag" stripe @selection-change="handleSelectionChange" @row-click="cashDeskClick" :data="returnData.list" :height="tableHeight" border style="width: 100%" highlight-current-row
                      size="mini">
               <!-- 主信息 -->

               <el-table-column header-align='center' label="选择操作" width="80">
                  <template slot-scope="scope">
                     <el-radio v-model="selectedRowIndex" :label="scope.$index" border size="mini" @change="handleRadioChange(scope.row, scope.$index)">
                        <i class="el-icon-thumb"></i>
                     </el-radio>
                  </template>
               </el-table-column>
               <el-table-column v-for="(tableValye, tableKey) in pageShowData" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                  <template slot-scope="scope">
                     <span v-if="tableValye.fieldType == 'date'">
                        <span v-if="scope.row[tableValye.entityField]">
                           {{ $common.getLocalTime(scope.row[tableValye.entityField]) }}
                        </span>
                     </span>

                     <el-tag v-else-if="tableValye.entityField == 'deskState'" size="mini" :type="scope.row.deskState == 0 ? 'danger' : 'success'">
                        {{ scope.row.deskState == 0 ? "禁用" : "启用" }}</el-tag>

                     <span v-else-if="tableValye.entityField == 'isSmall'">
                        <el-tag size="mini" v-if="scope.row.isSmall == 1">是</el-tag>
                        <el-tag size="mini" v-if="scope.row.isSmall == 0">否</el-tag>
                     </span>
                     <span v-else-if="tableValye.isRift == 1">
                        <a @click="toDetail(scope.row[tableValye.riftField])">{{
                           scope.row[tableValye.entityField]
                        }}</a>
                     </span>

                     <el-input clearable style="width: 90px; margin: 0 1px" @blur="blur(scope.$index, tableValye.entityField)" v-else-if="tableValye.fieldType == 'input'" type="number"
                               v-model="scope.row[tableValye.entityField]"></el-input>
                     <span v-else>
                        {{ scope.row[tableValye.entityField] }}
                     </span>
                  </template>
               </el-table-column>
            </el-table>
            <div class="page_content_bottom">
               <v-pagination :page="getRequestData.page" :rows="getRequestData.rows" :total="returnData.total" @setDataPageSize="setDataPageSize" @setDataPageNumber="setDataPageNumber"></v-pagination>
            </div>
         </div>
         <div style="width: 25%">
            <div class="btns">
               <el-button type="primary" size="mini" @click="openPer">新增
               </el-button>
               <el-button type="primary" size="mini" @click="saveDeskBook">保存
               </el-button>
            </div>
            <el-table class="mainTable xunjia" ref="mxTable" :data="DeskBookList" :height="tableHeight" :key="$store.state.tableNum" border style="width: 100%" highlight-current-row size="mini">
               <el-table-column label="绑定账簿列表">
                  <el-table-column v-for="(tableValye, tableKey) in pageShowPeopleData" :key="tableKey" align="center" :prop="tableValye.entityField" :label="tableValye.showField" show-overflow-tooltip
                                   :min-width="tableValye.fieldWeight" :fixed="tableValye.fixed || false">
                     <template slot-scope="scope">
                        <span>{{ scope.row[tableValye.entityField] }}</span>
                     </template>
                  </el-table-column>
               </el-table-column>
               <el-table-column label="操作" align="center" min-width="180px">
                  <template slot-scope="scope">
                     <el-button type="primary" size="mini" @click="moveUp(scope.$index)" :disabled="scope.$index === 0">上移</el-button>
                     <el-button type="primary" size="mini" @click="moveDown(scope.$index)" :disabled="scope.$index === DeskBookList.length - 1">下移</el-button>
                     <el-button type="danger" size="mini" @click="delDetail(scope.$index)">删除</el-button>
                  </template>
               </el-table-column>
            </el-table>
         </div>
      </div>

      <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth">
         <SearchScheme ref="searchScheme" :id="seId" @TranData="changeInputModel" @getWidth="getSeWidth" @sendTitle="getSearchName" :parentSearchData="parentSearchData" />
      </el-dialog>
      <!-- <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth">
          <ExtractionScheme ref="extractionScheme" :id="exId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
       </el-dialog> -->
      <!-- 账簿列表 -->
      <el-dialog title="绑定账簿列表" v-if="LsAbook" :visible.sync="LsAbook">
         <div style="margin-bottom: 15px;">
            <el-input v-model="searchPersonName" placeholder="请输入账簿名称进行筛选" clearable style="width: 300px;border-radius: 0 !important;" @input="handlePersonSearch" @clear="handlePersonSearch"
                      @keyup.enter.native="handlePersonSearch">

            </el-input>
            <el-button type="primary" @click="handlePersonSearch" clearable style="border-radius: 0;">搜索</el-button>
         </div>
         <el-table :data="perList" ref="perList" border @selection-change="handleSelectionChange" height="450px" size="mini" v-loading="loading">
            <el-table-column type="selection" width="40"></el-table-column>
            <el-table-column property="abookCode" label="账簿编号" show-overflow-tooltip></el-table-column>
            <el-table-column property="abookName" label="账簿名称" show-overflow-tooltip></el-table-column>
            <el-table-column property="abookNumber" label="财务科目号" show-overflow-tooltip> </el-table-column>
            <el-table-column property="abookType" label="账簿类型" show-overflow-tooltip>
               <template slot-scope="scope">
                  <span>{{ scope.row.abookType == 0 ? "对公" : "对私" }}</span>
               </template>
            </el-table-column>
            <el-table-column property="abookType" label="账簿用途" show-overflow-tooltip>
               <template slot-scope="scope">
                  <span>{{ scope.row.abookType == 1 ? "结算" : "零售" }}</span>
               </template>
            </el-table-column>
            <el-table-column property="abookAccount" label="账簿总金额" show-overflow-tooltip></el-table-column>
         </el-table>
         <div slot="footer" class="dialog-footer">
            <el-button @click="LsAbook = false">取 消</el-button>
            <el-button type="primary" @click="selPerson">确 定</el-button>
         </div>
      </el-dialog>

      <!-- 人员绑定穿梭框弹窗 -->
      <el-dialog title="绑定人员" :visible.sync="bindPersonDialogVisible" width="1050px">
         <el-transfer v-model="bindedPersonKeys" :data="personTransferData" :titles="['可选人员', '已绑定人员']" :props="{ key: 'opmId', label: 'opmName' }" :button-texts="['移除', '绑定']" :render-content="renderPerson"
                      :loading="loading" style="height:400px">
         </el-transfer>
         <div slot="footer" class="dialog-footer">
            <el-button @click="bindPersonDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="confirmBindPerson">确 定</el-button>
         </div>
      </el-dialog>

      <GoodsQrCode ref="GoodsQrCode"></GoodsQrCode>

      <customDesign ref="customDesign"></customDesign>
   </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';

import SearchScheme from "../../../byComponents/SearchScheme.vue"
import ExtractionScheme from "../../../byComponents/ExtractionScheme.vue"
import GoodsQrCode from "../../../byComponents/GoodsQrCode.vue"
// 门店新增/编辑组件
import cashDeskModal from "./cashDeskModal.vue"
import { nameList, deskBookList, searchList } from "./cashDeskList.js"
export default {
   //import引入的组件需要注入到对象中才能使用
   components: {
      SearchScheme,
      ExtractionScheme,
      GoodsQrCode,
      cashDeskModal,
   },
   data() {
      //这里存放数据
      return {
         exId: "1",

         sField: "",
         dialogTitle: "",

         seType: "",
         seIndex: 0,
         exTitle: "",

         exWidth: "",

         DialogExtract: false,
         chenform: {},
         searchList: searchList,
         tableData: [
            {
               createTime: "2016-05-02",
               bgmName: "王小虎",
               pspmId: "上海市普陀区金沙江路 1518 弄",
            },
            {
               createTime: "2016-05-04",
               bgmName: "王小虎",
               pspmId: "上海市普陀区金沙江路 1517 弄",
            },
         ],
         getRequestData: {
            businessId: "",
            creater: 0,
            ormId: 0,
            page: 1,
            rows: 30,
            start: "",
            end: '',
            storeName: "",
            salesPersonName: "",
            deskType: "",
            isSmall: "",
         },
         requestData: {},
         returnData: {
            pages: 0, // 总页数
            total: 0, // 总条数
            pageNum: 0, // 当前页数
            list: [],
         },
         buttonList: [],
         //---------------
         seTitle: "",
         DialogVisible: false,
         seId: "",
         setField: "",
         setType: "",
         seWidth: "0",
         parentSearchData: {},
         //---------------

         multipleSelection: [],
         multipleSelectionPerson: [],
         pageShowData: {},
         pageShowPeopleData: {},
         tableFlag: 0,
         formDataList: [],
         selectedDataIndex: 0,
         selectedDetailsDataIndex: "",

         deskIds: "",
         storeIds: "",
         DeskBookList: [],
         defaultData: {
            opmId: 0,
            abookName: "",
            deskId: 0,
            remark: ""
         },
         tableHeight: 0,
         DialogqrCode: false,
         goodsInfo: "",
         smNames: "",
         showStatus: false,
         actionData: {},
         LsAbook: false,
         perList: [],
         personList: [],
         loading: false,
         searchPersonName: "",
         selectedRowIndex: null,
         bindPerson: false,
         searchPerson: "",
         bindPersonList: [],
         addPersonVisible: false,
         personAddList: [],
         // 人员穿梭框相关
         bindPersonDialogVisible: false,
         personTransferData: [], // 所有可选人员
         bindedPersonKeys: [],   // 已绑定人员的key
      }
   },
   //监听属性 类似于data概念
   computed: {},
   //监控data中的数据变化
   watch: {
      "getRequestData.smName": {
         handler: function (newValue, oldValue) {
            if (newValue == "") {
               this.getRequestData.pspmBuycus = ""
            }
         },
         deep: true,
      },
   },
   //方法集合
   methods: {
      // 子组件触发
      drawerCancel(e) {
         console.log(e, "+++++++++")
         this.showStatus = false
         // this.getDataList()
      },
      // 点击穿透字段 传参单号
      toDetail(orderId) {
         //  if (orderId) {
         //     // 设置为true 打开穿透组件首页
         //     var isPenetrate = true
         //     // 设置缓存 存入点击单号
         //     this.resetSetItem('penetrateOrderId', orderId);
         //     // 与父级跨域通信 传递isPenetrate参数
         //     window.parent.postMessage({  //向窗口发送MessageEvent消息
         //        cmd: 'returnFormJson',
         //        params: { isPenetrate } //参数
         //     }, '*');
         //  }
         this.getPageInfo()
      },
      openFormDesign() {
         let pathInfo = parent.getMenuInfo(this.$route.path)

         this.$refs["customDesign"].openBox(
            pathInfo.jurId,
            this.pageShowData,
            pathInfo.jurName
         )
      },
      cashDeskClick(row) {
         this.deskIds = row.deskId
         this.storeIds = row.storeId
         this.selectedRowIndex = this.returnData.list.findIndex(item => item.deskId === row.deskId)
         this.getDataDeskBookList()
      },

      // 检索Id, 索引(表格中), 标识
      openSearch(val) {
         this.setType = val.type
         this.seId = val.sId
         this.setField = val.sField
         this.parentSearchData[this.setType] = this.getRequestData[this.setType]
         if (this.setType == 'salesName') {
            this.parentSearchData.opmSalesperson = 1
         }
         this.DialogVisible = true

      },

      // 赋值字段
      paramValue(val) {
         if (this.setType == 'storeName') {
            this.parentSearchData.storeId = val.storeId
         }
         let arr = this.setField.split(',')
         arr.forEach(item => {
            this.getRequestData[item] = val[item]
         })
      },
      //检索方案返回的数据
      changeInputModel(val) {
         if (val) {
            if (this.setType == 'salesName') {
               this.getRequestData.salesName = val.opmName
               this.getRequestData.salesId = val.opmId
            } else {
               this.paramValue(val)
            }
         }
         this.DialogVisible = false
      },
      //   新增账簿
      openPer() {
         this.LsAbook = true;
         this.searchPersonName = ""; // 重置搜索条件
         this.queryOperator();
      },
      //   新增人员
      async openPerson() {
         this.bindPersonDialogVisible = true;
         this.loading = true;
         // 获取所有可选人员
         let allRes = await this.$http.queryStoreBindUser({
            storeId: this.storeIds,
            page: 1,
            rows: 1000,
         });
         // 获取已绑定人员
         let bindedRes = await this.$http.queryCashdeskMem({
            ids: [this.deskIds]
         });
         this.loading = false;
         if (allRes.status == 200 && bindedRes.status == 200) {
            this.personTransferData = (allRes.result.list || []).map(item => ({
               ...item,
               key: item.opmId, // el-transfer要求有key字段
               label: item.opmName // el-transfer要求有label字段
            }));
            const bindedIds = (bindedRes.result || []).map(item => item.opmId);
            this.bindedPersonKeys = bindedIds;
         } else {
            this.personTransferData = [];
            this.bindedPersonKeys = [];
            this.$message.error('人员数据加载失败');
         }
      },
      // 账簿搜索处理
      handlePersonSearch() {
         this.queryOperator();
      },
      // 新增人员
      addPerson() {
         this.addPersonVisible = true;
         this.queryAddPerson();
      },
      //查询账簿列表
      async queryOperator() {
         this.loading = true;
         let params = {
            businessId: "",
            creater: 0,
            end: 0,
            abookName: this.searchPersonName || "",
            ormId: 0,
            page: 1,
            rows: 1000,
            start: 0,
            deskId: this.deskIds
         };
         let responseData = await this.$http.queryLsAbook(params);
         this.loading = false;
         if (responseData && responseData.status == 200) {
            // 直接显示所有账簿，不进行过滤
            this.perList = responseData.result || [];
            // 数据加载完成后自动勾选已绑定的账簿
            this.$nextTick(() => {
               this.autoSelectExistingBooks();
            });
         } else {
            this.perList = [];
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //查询已绑定的人员列表
      async queryPerson() {
         this.loading = true;

         let responseData = await this.$http.queryCashdeskMem({
            ids: [this.deskIds]
         });
         this.loading = false;
         if (responseData && responseData.status == 200) {

            this.personList = responseData.result || [];

         } else {
            this.personList = [];
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      //查询新增绑定的人员列表
      async queryAddPerson() {
         this.loading = true;

         let responseData = await this.$http.queryStoreBindUser({
            businessId: "",
            creater: 0,
            end: 0,
            opmName: "",
            ormId: 0,
            page: 0,
            rows: 0,
            start: 0,
            storeId: this.storeIds,
         });
         this.loading = false;
         if (responseData && responseData.status == 200) {

            this.personAddList = responseData.result.list || [];
            this.$nextTick(() => {
               this.autoSelectExistingPerson();
            });
         } else {
            this.personAddList = [];
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      handleSelectionChange(val) {
         console.log(val, "+++++++++")
         this.multipleSelection = val
      },
      handleSelectionPersonChange(val) {
         console.log(val, "+++++++++")
         this.multipleSelectionPerson = val
      },
      async selPerson() {
         // 直接保存所有勾选的账簿，不进行重复检查
         const addList = this.multipleSelection;

         // 准备保存的数据
         let pushData = {
            deskbookDetailList: addList.map((item, idx) => ({ abookId: item.abookId, sort: '' })),
            deskId: this.deskIds,
         };

         // 直接调用保存接口
         let responseData = await this.$http.addCashdeskBook(pushData);
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });
            // 重新获取账簿列表
            this.getDataDeskBookList();
            // 关闭对话框
            this.LsAbook = false;
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },

      async selBindPerson() {
         // 直接保存所有勾选的人员，不进行重复检查
         const addList = this.multipleSelectionPerson;

         // 准备保存的数据
         let pushData = {
            deskId: this.deskIds,
            opmIds: addList.map((item) => (item.opmId)),
            isCashier: 1
         };

         // 直接调用保存接口
         let responseData = await this.$http.addCashdeskMem(pushData);
         if (responseData.status == 200) {
            this.$message({
               message: "操作成功",
               type: "success",
            });

            // 关闭对话框
            this.addPersonVisible = false;
            this.queryPerson();
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            });
         }
      },
      async delDetail(index) {
         this.$confirm("确定删除该记录吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               try {
                  // 调用删除接口
                  let responseData = await this.$http.delCashdeskBook({
                     ids: [this.DeskBookList[index].id],
                  });

                  if (responseData.status == 200) {
                     // 从列表中删除
                     this.DeskBookList.splice(index, 1);
                     this.$message({
                        type: "success",
                        message: "删除成功!",
                     });
                     this.getDataDeskBookList()
                  } else {
                     this.$message({
                        message: responseData.message,
                        type: "error",
                     });
                  }
               } catch (error) {
                  this.$message({
                     message: "删除失败，请重试",
                     type: "error",
                  });
               }
            })
            .catch(() => { });
      },

      changeInput(row) {
         // console.log('changeInput', row);
         row["edit"] = true
         // this.returnData.searchList.splice(1, 0)
         // this.$refs.minTable.doLayout()
      },
      // 勾选明细
      handleSelectionChange(val) {
         console.log(val, "+++++++++")
         this.multipleSelection = val
      },
      getDataByChen(val) {
         console.log(val)
         this.DialogExtract = false
         this.tableData = val.arrlistbychen
         this.chenform = val
      },

      // 处理单选框变化
      handleRadioChange(row, index) {
         this.selectedRowIndex = index;
         this.deskIds = row.deskId;
         this.getDataDeskBookList();
      },

      // 上移
      moveUp(index) {
         if (index > 0) {
            // 使用Vue的响应式方法来交换位置
            const temp = this.DeskBookList[index];
            this.$set(this.DeskBookList, index, this.DeskBookList[index - 1]);
            this.$set(this.DeskBookList, index - 1, temp);
         }
      },

      // 下移
      moveDown(index) {
         if (index < this.DeskBookList.length - 1) {
            // 使用Vue的响应式方法来交换位置
            const temp = this.DeskBookList[index];
            this.$set(this.DeskBookList, index, this.DeskBookList[index + 1]);
            this.$set(this.DeskBookList, index + 1, temp);
         }
      },

      // 保存排序
      async saveDeskBook() {
         if (this.DeskBookList.length === 0) {
            this.$message({
               message: "没有账簿数据需要保存",
               type: "warning",
            });
            return;
         }

         try {
            // 准备保存的数据，包含排序信息
            let pushData = {
               deskbookDetailList: this.DeskBookList.map((item, idx) => ({
                  abookId: item.abookId,
                  sort: idx,
                  // id: item.id // 保留原有ID用于更新
               })),
               deskId: this.deskIds,
            };

            // 调用保存接口
            let responseData = await this.$http.addCashdeskBook(pushData);
            if (responseData.status == 200) {
               this.$message({
                  message: "排序保存成功",
                  type: "success",
               });
               // 重新获取数据
               this.getDataDeskBookList();
            } else {
               this.$message({
                  message: responseData.message,
                  type: "error",
               });
            }
         } catch (error) {
            this.$message({
               message: "保存失败，请重试",
               type: "error",
            });
         }
      },

      getSeWidth(e) {
         console.log(e)
         this.seWidth = e + "%"
      },
      getWidth(e) {
         console.log(e)
         this.exWidth = e + "%"
      },
      getSearchName(e) {
         console.log(e)
         this.seTitle = e
      },
      getExtractName(e) {
         console.log(e)
         this.exTitle = e
      },



      // 获取数据列表
      async getPageInfo() {
         this.pageShowData = JSON.parse(JSON.stringify(nameList))
         this.pageShowPeopleData = JSON.parse(JSON.stringify(deskBookList))

         let res = await this.$http.queryCashDeskList(this.getRequestData)
         if (res.status == 200) {
            this.returnData.list = res.result.list
            this.returnData.total = res.result.total
            this.returnData.pageNum = res.result.pageNum
            this.returnData.pages = res.result.pages
            this.selectedDataIndex = 0
            if (this.returnData.list.length > 0) {
               this.deskIds = this.returnData.list[0].deskId
               this.storeIds = this.returnData.list[0].storeId
               this.getDataDeskBookList()
               this.$nextTick(() => {
                  this.selectedRowIndex = 0
                  this.multipleSelection = [this.returnData.list[0]]
               })
            } else {
               this.DeskBookList = []
            }
         } else {
            this.$message({
               message: res.message,
               type: "error",
            })
         }

      },
      // 动作集合
      async actionSet(actionData) {
         console.log(actionData.actionType)
         switch (actionData.actionType) {
            case 0:
               this.showStatus = true
               this.actionData = {
                  cate: 0,
                  formData: [],
                  oldData: "",
               }
               break
            case 1:
               if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
                  this.$message({
                     message: "请先选中要操作的数据",
                     type: "error",
                  })
                  return false
               }
               this.showStatus = true
               this.actionData = {
                  cate: 1,
                  formData: [],
                  oldData: this.returnData.list[this.selectedRowIndex],
               }
               break
            case 2:
               this.delDataAction()
               break
            case 4:
               this.openPerson()
               break
            //  case 6:
            //  if (this.multipleSelection.length == 0) {
            //     this.$message({ type: "error", message: "请先选中要操作的数据" })
            //     return
            //  }
            //  let responseData = await this.$http.disableStore({
            //     ids: this.multipleSelection.map((item) => item.deskId),
            //  })
            //  if (responseData.status == 200) {
            //     this.$message({
            //        type: "success",
            //        message: "停用成功!",
            //     })
            //  } else {
            //     this.$message({
            //        message: responseData.message,
            //        type: "error",
            //     })
            //  }
            //  this.getDataList()
            //  break;

         }
      },
      // openActionBox(cate) {
      //    // this.initActionBox()
      //    if (cate == 0) {
      //       this.dataActionBox.boxTitle = "新增信息"
      //       this.dataActionBox.openMode = "ltr"
      //    } else {
      //       this.dataActionBox.boxTitle = "编辑信息"
      //       this.dataActionBox.openMode = "rtl"
      //    }
      //    this.dataActionBox.actionType = cate
      //    this.dataActionBox.showStatus = true
      // },
      // 数据搜索
      searchData() {
         this.getRequestData.page = 1
         this.getDataList()
      },
      // 数据翻页
      setDataPageNumber(val) {
         this.getRequestData.page = val
         this.getDataList()
      },

      // 切换显示条数
      setDataPageSize(val) {
         this.getRequestData.page = 1
         this.getRequestData.rows = val
         this.getDataList()
      },

      // 获取数据列表 门店
      async getDataList() {
         let responseData = await this.$http.queryCashDeskList(this.getRequestData)
         if (responseData.status == 200) {
            this.returnData.list = responseData.result.list
            this.returnData.total = responseData.result.total
            this.returnData.pageNum = responseData.result.pageNum
            this.returnData.pages = responseData.result.pages
            this.selectedDataIndex = 0
            if (this.returnData.list.length > 0) {
               this.deskIds = this.returnData.list[0].deskId
               this.storeIds = this.returnData.list[0].storeId
               this.getDataDeskBookList()
               this.$nextTick(() => {
                  this.selectedRowIndex = 0
                  this.multipleSelection = [this.returnData.list[0]]
               })
            } else {
               this.DeskBookList = []
            }
            this.$nextTick(() => {
               this.tableHeight = this.$common.getTableHeight()
               this.tableFlag++
            })
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            })
         }
      },
      // 查询收款台绑定账簿
      async getDataDeskBookList() {
         this.DeskBookList = []
         let responseData = await this.$http.queryCashdeskBook({
            ids: [this.deskIds]
         })
         if (responseData.status == 200) {
            this.DeskBookList = Array.isArray(responseData.result)
               ? responseData.result
               : []
         } else {
            this.$message({
               message: responseData.message,
               type: "error",
            })
         }
      },
      // 删除数据
      delDataAction() {
         if (this.selectedRowIndex === null || this.selectedRowIndex < 0) {
            this.$message({
               message: "请先选中要操作的数据",
               type: "error",
            })
            return false
         }

         this.$confirm("此操作将永久删除该数据, 是否继续?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
         })
            .then(async () => {
               var delData = {
                  ids: [this.returnData.list[this.selectedRowIndex].deskId],
               }
               let responseData = await this.$http.delcashdesk(delData)
               if (responseData.status == 200) {
                  this.$message({
                     type: "success",
                     message: "删除成功!",
                  })

                  this.getDataList()
               } else {
                  this.$message({
                     message: responseData.message,
                     type: "error",
                  })
               }
            })
            .catch(() => { })
      },

      async getButtonList() {
         this.buttonList = await this.$common.getActionButton()
      },


      // 自动勾选已绑定的账簿
      autoSelectExistingBooks() {
         // 等待DOM更新完成
         this.$nextTick(() => {
            if (this.$refs.perList && this.DeskBookList.length > 0 && this.perList.length > 0) {
               const existIds = this.DeskBookList.map(item => item.abookId);

               // 先清空所有选择
               this.$refs.perList.clearSelection();

               // 勾选已绑定的账簿
               this.perList.forEach(row => {
                  if (existIds.includes(row.abookId)) {
                     this.$refs.perList.toggleRowSelection(row, true);
                  }
               });

               // 同步 multipleSelection
               this.multipleSelection = this.perList.filter(row => existIds.includes(row.abookId));
            }
         });
      },
      // 自动勾选已绑定的人员
      autoSelectExistingPerson() {
         // 等待DOM更新完成
         this.$nextTick(() => {
            if (this.$refs.personAddList && this.personAddList.length > 0 && this.personAddList.length > 0) {
               const existIds = this.personAddList.map(item => item.opmId);

               // 先清空所有选择
               this.$refs.personAddList.clearSelection();

               // 勾选已绑定的账簿
               this.perList.forEach(row => {
                  if (existIds.includes(row.opmId)) {
                     this.$refs.personAddList.toggleRowSelection(row, true);
                  }
               });

               // 同步 multipleSelection
               this.multipleSelection = this.personAddList.filter(row => existIds.includes(row.opmId));
            }
         });
      },
      // 确定绑定
      async confirmBindPerson() {
         let pushData = {
            deskId: this.deskIds,
            opmIds: this.bindedPersonKeys,
            isCashier: 1
         };
         let responseData = await this.$http.addCashdeskMem(pushData);
         if (responseData.status == 200) {
            this.$message.success("操作成功");
            this.bindPersonDialogVisible = false;
         } else {
            this.$message.error(responseData.message);
         }
      },
      // 可选：自定义渲染内容（显示更多字段）
      renderPerson(h, option) {
         return h('span', null, `${option.opmName}（${option.opmMobilenumber || ''}）`);
      },
   },
   //生命周期 - 创建完成（可以访问当前this实例）
   created() {
      this.getPageInfo()
      this.getButtonList()
   },
   //生命周期 - 挂载完成（可以访问DOM元素）
   mounted() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight()
         this.tableFlag++
      })
   },
   updated() {
      this.$nextTick(() => {
         this.tableHeight = this.$common.getTableHeight()
      })
   }, //生命周期 - 更新之后

}
</script>
<style scoped>
.table_content_tag {
   margin-right: 1rem;
}

.el-tabs--border-card_new {
   height: 85vh;
   overflow-y: scroll;
}

.btns {
   display: flex;

   /* position: absolute; */
   z-index: 999;
   /* right: 100px; */
   padding-left: 10px;
   padding-top: 2px;
}

::v-deep.xunjia tr {
   height: 39px !important;
}

::v-deep.xunjia .el-button {
   font-size: 12px;
   padding: 5px 10px;
}

::v-deep.xunjia .el-button--danger {
   color: #fff;
   background-color: #f56c6c;
   border-color: #f56c6c;
}

::v-deep.xunjia .el-button--danger:hover {
   color: #fff;
   background-color: #f78989;
   border-color: #f78989;
}

::v-deep.xunjia .el-table__fixed-right {
   height: 100% !important;
   position: absolute;
   top: 0;
   overflow: hidden;
   background-color: #fff;
   z-index: 3;
}

::v-deep.xunjia .el-table__fixed-right-patch {
   background-color: #fff;
}
::v-deep .el-transfer-panel {
   width: 400px !important;
}
</style>